// extracted by mini-css-extract-plugin
export default {"select":"Select_select__ZyN6-","invalid":"Select_invalid__YqNQJ"};